import React from 'react';
import { Loader, LoaderProps } from '@mantine/core';

export function ELoader({ ...props }: LoaderProps) {
    return (
        <Loader
            size="sm"
            {...props}
        />
    )
}
